function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { sdkLogger } from '../../logger';
import { TestingOverrides } from '../services/testing-overrides';
import { secondsToMs } from '../../utils/time-util';
var ENTER_EVENT_DELAY_FOR_TESTING = 10000;
var EVENT_DURATION_FOR_TESTING = 5000;
export var LiveActionManager = /*#__PURE__*/ function() {
    "use strict";
    function LiveActionManager() {
        _class_call_check(this, LiveActionManager);
        _define_property(this, "logger", sdkLogger.withContext('LAM'));
        _define_property(this, "registerCue", void 0);
        _define_property(this, "usedIDs", new Set());
    }
    _create_class(LiveActionManager, [
        {
            key: "start",
            value: function start(registerCue, metaListManager, cdns, options) {
                var startIndex = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
                this.registerCue = registerCue;
                metaListManager.registerCallBack(this.handleResponse.bind(this));
                metaListManager.handleStartPooling(cdns, options, startIndex);
            }
        },
        {
            key: "handleResponse",
            value: function handleResponse(jsonResponse) {
                var timelineEvents = jsonResponse.timelineEvents;
                if (timelineEvents) {
                    for(var i = 0; i < timelineEvents.length; i++){
                        var _timelineEvents_i = timelineEvents[i], persistent = _timelineEvents_i.persistent, id = _timelineEvents_i.id, timelineEvent = _object_without_properties(_timelineEvents_i, [
                            "persistent",
                            "id"
                        ]);
                        if (this.usedIDs.has(id)) {
                            continue;
                        }
                        this.usedIDs.add(id);
                        var startTime = void 0, endTime = void 0;
                        if (TestingOverrides.liveActionsTestCustomEvents) {
                            var startTimeNumber = new Date().getTime() + ENTER_EVENT_DELAY_FOR_TESTING * (i + 1);
                            startTime = new Date(startTimeNumber);
                            endTime = new Date(startTimeNumber + EVENT_DURATION_FOR_TESTING);
                        } else {
                            startTime = new Date(secondsToMs(timelineEvent.startTime));
                            endTime = new Date(secondsToMs(timelineEvent.endTime));
                        }
                        this.registerCue(_object_spread_props(_object_spread({}, timelineEvent), {
                            startTime: startTime,
                            endTime: endTime,
                            isPersistent: persistent
                        }));
                    }
                    return true;
                }
                this.logger.warn("Live Actions not received");
                return false;
            }
        }
    ]);
    return LiveActionManager;
}();

//# sourceMappingURL=live-action-manager.js.map